/**
 * Use this in a switch statement's default case to ensure that all cases are handled.
 */
export function assertUnreachable(_x: never): never {
  throw new Error("Didn't expect to get here: " + JSON.stringify(_x))
}

/**
 * Use this in filtering an array to remove null and undefined elements and update the array's type to reflect that.
 *
 * @example
 * ```typescript
 * const ids = [1, 2, null, undefined, 3]; // Type is (number | null | undefined)[]
 * const realIds = ids.filter(nonNullable); // Type is now number[]
 * ```
 */
export function nonNullable<T>(x: T): x is NonNullable<T> {
  return x != null;
}
